module.exports = __webpack_public_path__ + "static/media/table_column_edit_title.0525b550.png";